import React from 'react'

export default ({ to, title, children, onClick }) => (
  <a
    href={to}
    target="_blank"
    aria-label={title}
    title={title}
    rel="nofollow noopener"
    onClick={onClick}
  >
    {children}
  </a>
)



// WEBPACK FOOTER //
// ./src/components/external-link.js